module.exports = __webpack_public_path__ + "static/media/slide-7.32779778.jpg";